<template>
	<div>
		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix" style="display: flex;justify-content: space-between;">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
								v-model="quertInfo.searchTime" start-placeholder="开始日期" value-format="yyyy-MM-dd"
								style="width: 210px" end-placeholder="结束日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入询价标题、询价单号" clearable v-model="quertInfo.objMap.keyword"
								style="width: 240px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
                        <el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入物料编码、物料名称" clearable v-model="quertInfo.objMap.productKeyWord"
								style="width: 240px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" @click="onSearch" >查询 </el-button>
						</el-form-item>
					</el-form>
					<div>
						<el-button size="mini" v-if="checkRole('cgy_role') && pageFlag == 'all' || checkRole('cgy_role') && pageFlag=='inquiry'" type="primary" @click="handleAdd"> 新增 </el-button>
						<el-button size="mini" v-if="pageFlag=='inquiry' && checkRole('cgy_role')" type="primary" :disabled="ids.length<1" @click="handleBatchDel"> 批量删除</el-button>
					</div>
				</div>
				<!-- 订单列表 -->
				<OrderTable ref="OrderTableRef" :pageFlag="pageFlag" :tableData="tableData" :loading="loading" @callback="OrderTableCallback" :currencyObj="currencyInfo.obj" :count="count" :tableHeight="PAGESIZE.h-290" />
			</el-card>
		</el-row>
		<!-- 新增、编辑 -->
		<EditDialog ref="EditDialogRef" @callback="EditDialogCallback" :currencyData="currencyInfo.list" />
		<!-- 订单详情 -->
		<el-drawer title="我是标题" :visible.sync="drawer" custom-class="my-el-drawer" :with-header="false" size='60%'>
			<div class="my-el-drawer-body">
				<el-row type="flex" class="app-main-header mg-b15" align="middle">
					<el-col :span="6">
						<div class="router-title">
							<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}预览</span>
						</div>
					</el-col>
					<el-col :span="18" class="app-main-header-btns">
						<el-button type="primary" size="small" @click="handleEdit(form)"
							v-hasPermi="['srm:inquiry:edit']">编辑
						</el-button>
					</el-col>
				</el-row>
				<el-collapse v-model="activeNames">
					<el-collapse-item name="1">
						<template slot="title">
							<div style="display: flex;align-items: center;">
								<el-divider direction="vertical"></el-divider>
								<span>询价单</span>
							</div>
						</template>
						<el-card shadow="hover" style="border: none;">
							<el-descriptions :column="2" :border="false" :colon="false">
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="创建时间">
									{{form.createTime}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="创建人">
									{{form.createUser}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="报价截止时间">
									{{form.bjJzTime}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="询价单号">
									{{form.xjOrder}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="询价单标题1">
									{{form.title}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="发起单位">
									{{form.unitCode}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="单据类型">
									{{form.djType}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="询价方式">
									{{form.xjFs}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="汇率">
									{{form.hl}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="竞价方向">
									{{form.biddingFx}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="公开规则">
									{{form.openRule}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="竞价排名">
									{{form.biddingSort}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="状态">
									{{form.status}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="货币种类">
									{{form.currency}}
								</el-descriptions-item>
								<el-descriptions-item contentClassName="my-descriptions-conten"
									labelClassName="my-descriptions-label" label="备注">
									{{form.remark}}
								</el-descriptions-item>
							</el-descriptions>
						</el-card>
					</el-collapse-item>
				</el-collapse>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import { inquiryList, delInquiry, batchDelInquiry, exportInquiry } from '@/api/srm/inquiry.js'
	import { basicCurrencyList } from '@/api/basic/basicCurrency.js'
	import OrderTable from '@/components/OrderTable'
	import EditDialog from './EditDialog'
	export default {
		props:['pageFlag'],
		name: "xjOrderTable",
		components:{
			OrderTable,EditDialog
		},
		computed: {
			PAGESIZE:function(){
				return this.$store.getters['app/sizeInfo'];
			},
			currencyInfo:function(){
				return this.$store.getters['app/currencyInfo'];
			},
		},
		data() {
			return {
				loading:false,
				tableData: [],
				ids: [],
				form:{},
				activeNames: ['1'],
				loadingInstance: undefined,
				drawer: false,
				count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						keyword: '',
						productKeyWord: '',
						orderState:'',		 // 1:待询价,2:询价中,3:已结束询价待审批,4:询价审批中,5:定标审批被驳回,6:定标审批通过,7:已发布中标通知,
					}
				},
			};
		},
		created() {
			this.quertInfo.objMap.orderState = this.getOrderStatus(this.pageFlag);
			this.getList();
		},
		methods: {
			getOrderStatus(type){
				let state = '';
				if(this.pageFlag == 'all'){
					state = '';
				}
				if(this.pageFlag == 'inquiry'){
					state = 1;
				}
				if(this.pageFlag == 'inquiryIng'){
					state = 2;
				}
				if(this.pageFlag == 'tenderOrder'){
					state = 3;
				}
				if(this.pageFlag == 'awaitAuditOrder'){
					state = 4;
				}
				if(this.pageFlag == 'endAuditOrder'){
					state = 6;
				}
				if(this.pageFlag == 'noticeAward'){
					state = 7;
				}
				return state
			},
			OrderTableCallback: function(obj){
				if(obj.type == 'pagination'){	// 页码改变
					this.quertInfo.page = obj.info.page;
					this.quertInfo.limit = obj.info.limit;
					console.log(this.$route)
					this.getList();
				}
				if(obj.type == 'edit'){	// 修改
					this.handleEdit(obj.info)
				}
				if(obj.type == 'del'){	// 删除
					this.handleDel(obj.info.id)
				}
				if(obj.type == 'enquiry'){	// 发起询价
					this.handleEnquiry(obj.info)
				}
				if(obj.type == 'selecttable'){
					this.ids = obj.info;
				}
				if(obj.type == 'info'){
					// this.$router.push({path: `/auditinfo?hId=${obj.info.id}`});
					// this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${obj.info.id}&show=false&auditShow=true`});
					window.open(`/orderAuditInfo?hId=${obj.info.id}&show=false&auditShow=true`)
				}
			},
			async getList() {
				let _this = this;
				_this.loading = true;
				const {
					data: res
				} = await inquiryList(_this.quertInfo)
				_this.loading = false
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},

			// 新增、编辑回调
			EditDialogCallback(obj){
				if(obj.type == 1 || obj.type == 2){
					this.getList()
				}

			},
			handleAdd: function() {
				this.$refs.EditDialogRef.reset();
				this.$refs.EditDialogRef.title = "新增";
				this.$refs.EditDialogRef.openDialog = true;
			},
			handleEdit: function(row) {
				this.$refs.EditDialogRef.reset();
				this.$refs.EditDialogRef.title = "修改";
				let editForm = {...JSON.parse(JSON.stringify(row))}
				editForm.xjFs = editForm.xjFs+'';
				editForm.buyerUnitId = editForm.buyerUnitId+'';
				this.$refs.EditDialogRef.form = editForm; //直接赋值 表格数据 也会改变 要深拷贝复制
				this.$refs.EditDialogRef.openDialog = true;
			},
			handleSelectionChange(val) {
				this.ids = [];
				for (let item of val) {
					this.ids.push(item.id);
				}
			},
			handleBatchDel: function() {
				//批量删除
				let _this = this;
				if (_this.ids.length <= 0) {
					_this.$fail("请勾选要删除的行数据");
					return false;
				}
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						batchDelInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						ids: _this.ids
					} //参数对象 主要回调函数用
				});
			},
			// 发起询价
			handleEnquiry:function(row){
				this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${row.id}&show=false`});
			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			handleExport: function() {
				let _this = this;
				_this.confirm({
					text: '导出当前页，还是全部导出',
					but1: '全部导出',
					but2: '当前页',
					type: '',
					fn: function() {
						let param = JSON.parse(JSON.stringify(_this.quertInfo));
						param.page = 0;
						exportInquiry(param).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					cancel: function() {
						exportInquiry(_this.quertInfo).then(response => {
							if (response.data.code === 0) {
								_this.download(response.data.data);
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
				});
			},
			handleAvatarExcel(res, file) {
				if (res.code == 0) {
					this.getList();
				}
				this.loadingInstance.close();
				this.$success(res.msg);
			},
			beforeExcel(file) {
				// 判断文件后缀
				let type = file.name.substring(file.name.lastIndexOf('.') + 1);
				if (!(type == "xls" || type == "xlsx")) {
					this.$fail('请导入Excel文件');
					return false;
				}

				const isLt2M = file.size / 1024 / 1024 <= 1;
				if (!isLt2M) {
					this.$fail('导入Excel不能超过 1MB!');
					return false;
				}
				this.loadingInstance = this.Loading({
					text: '导入中请等待...'
				});
			},
		},
		watch:{
			pageFlag:function(val){
				this.tableData = [];
				this.quertInfo={
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					searchTime: [],
					objMap: {
						keyword: '',
						productKeyWord: '',
						orderState:this.getOrderStatus(val),		 // 1:待参与,2:已放弃,3:报价中,4:报价已提交,5:已中标,6:未中标,
					}
				};
				this.getList();
			}
		}
	};
</script>
<style scoped="scoped">
</style>
